module.exports = {
  field_is_required: 'This field is required',
  submission_error: 'The form could not be submitted. Please try again later.',
  next: 'Next',
  form_already_submitted: 'You have already submitted this form.',
}
